export default __webpack_public_path__ + "static/media/support.2f52fd21.png";